import BaseComponent from "../../baseComponent.js";
import InternalEvent from "../../../core/constants/internalEvent.js";
import styles from "../../common/tab.scss";

export default class CurrentTab extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      title: props.tab ? props.tab.title : ""
    };
    this.timeout = null;
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      title: nextProps.tab.title
    });
  }

  componentDidMount() {
    this.isEditMode = false;
    this.$title = $(this.refs.title);
    this.$titleInput = $(this.refs.titleInput);
    if (!isMobile()) {
      $(this.refs.tab).hover(() => {
        if (!this.isEditMode) {
          $(this.refs.actions).stop().fadeIn(200);
        }
      }, () => {
        $(this.refs.actions).stop().fadeOut(200);
      });
    }
  }

  enableEdit() {
    var _this = this;
    this.isEditMode = true;
    $(this.refs.actions).hide();
    this.$title.animate({opacity: 0}, 50, "easeInQuad", () => {
      this.$title.hide();
      this.$titleInput.show();
      this.$titleInput.animate({opacity: 1}, 100, "easeInQuad", () => {
        this.$titleInput.focus().select();
      });
    });
  }

  disableEdit() {
    this.isEditMode = false;
    this.$titleInput.animate({opacity: 0}, 100, "easeInQuad", () => {
      this.$titleInput.hide();
      this.$title.show();
      this.$title.animate({opacity: 1}, 20, "easeInQuad");
    });

    if (this.props.tab.title !== this.state.title) {
      this.props.onUpdate(this.props.tab.persistenceId, this.state.title);
    }
  }

  remove() {
    this.publish(InternalEvent.App.SHOW_APP_MODAL, {
      onAgree: () => {
        this.props.onDelete(this.props.tab.persistenceId)
      },
      header: "Do you really want to remove?"
    });
  }

  handleTitleChange(event) {
    this.setState({title: event.target.value});
  }

  render() {
    let editingElements, containerStyleForMobile;
    if (!isMobile()) {
      editingElements = <div style={{display: "flex"}}>
        <input type="text" className={styles.input} ref="titleInput"
               value={this.state.title} onChange={(e) => this.handleTitleChange(e)}
               onBlur={(e) => this.disableEdit(e)}/>
        <div className={styles.actions}>
          {
            this.props.tab.originalDashboard ?
              <div ref="actions">
                <i className="icon-docs" onClick={this.props.onCopy} style={{marginRight: '5px'}}/>
                <i className="icon-close" onClick={() => this.remove()}/>
              </div> :
              <div ref="actions">
                <i className="icon-share-alt" onClick={this.props.onShare} style={{marginRight: '5px'}}/>
                <i className="icon-docs" onClick={this.props.onCopy} style={{marginRight: '5px'}}/>
                <i className="icon-note" onClick={() => this.enableEdit()}/>
                <i className="icon-close" onClick={() => this.remove()}/>
              </div>
          }
        </div>
      </div>;
    } else {
      containerStyleForMobile = {"marginLeft": "0"};
    }
    return (
      <div className={styles.currentTab} ref="tab" style={containerStyleForMobile}>
        <div className={styles.title} ref="title">{this.state.title}</div>
        {editingElements}
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/dashboard/tab/currentTab.jsx